import React, { useContext, useState, useEffect } from "react";
import axios from "axios";
import styles from "./MarketFeed.module.css";
import { MarketContext } from "../../../context/MarketContext";
import BitCoinIcon from "../../../icon/BitCoinIcon";
import GoldIcon from "../../../icon/GoldIcon";
import { FaAngleDown } from "react-icons/fa6";
import { DiscordBanner } from "../../LeaderboardContent/LeaderboardContent";
import { GoArrowDownRight, GoArrowUpRight, GoClock } from "react-icons/go";
import { IoCopyOutline } from "react-icons/io5";
import { toast } from "react-toastify";
import { TbSquareRoundedMinus, TbSquareRoundedPlus } from "react-icons/tb";
import { PiWarning } from "react-icons/pi";
import { env } from "../../../constants/env";

const MarketFeed = ({ mobile }) => {
  const {
    tickers,
    selected,
    setSelected,
    positions,
    closePosition,
    closedPositions,
    balance,
    setBalance, // make sure you have a setter to update balance after redemption
  } = useContext(MarketContext);

  const [activeTab, setActiveTab] = useState("opened");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [remainingMap, setRemainingMap] = useState({});
  const [showHistory, setShowHistory] = useState(false);
  const [redeemStage, setRedeemStage] = useState("options");
  const [selectedTier, setSelectedTier] = useState(0);
  const [selectedRedeemOption, setSelectedRedeemOption] =
    useState("discountCodes");
  const [showBody, setShowBody] = useState(!mobile);

  // Redemption states
  const [errorMsg, setErrorMsg] = useState("");
  const [redemptionSuccess, setRedemptionSuccess] = useState(false);
  const [redeemSummary, setRedeemSummary] = useState(null);
  const [loading, setLoading] = useState(false);
  const [redemptionHistory, setRedemptionHistory] = useState([]);

  useEffect(() => {
    const map = {};
    positions.forEach((p) => (map[p.tradeId] = p.remaining));
    setRemainingMap(map);
  }, [positions]);

  const formatTime = (s) => {
    if (typeof s !== "number" || s < 0) return "00:00";
    const m = String(Math.floor(s / 60)).padStart(2, "0");
    const sec = String(s % 60).padStart(2, "0");
    return `${m}:${sec}`;
  };

  // const redemptionHistory = [
  //   {
  //     date: "26 Nov, 2025",
  //     redeemed: "PF-20-OCT29-9X7K",
  //     amount: "1000 $PROP (10% off)",
  //   },
  //   {
  //     date: "26 Nov, 2025",
  //     redeemed: "$10,000 funded accounts",
  //     amount: "5000 $PROP",
  //   },
  //   {
  //     date: "26 Nov, 2025",
  //     redeemed: "Next cohort spot",
  //     amount: "1000 $PROP",
  //   },
  //   {
  //     date: "26 Nov, 2025",
  //     redeemed: "PF-20-OCT29-9X7K",
  //     amount: "2000 $PROP (20% off)",
  //   },
  // ];

  const fetchRedemptionHistory = async () => {
    try {
      const res = await axios.get(`${env.apiUrl}/api/redeem`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("userToken")}`,
        },
      });
      if (res.data.success) {
        setRedemptionHistory(res.data.redemptions);
      }
    } catch (err) {
      console.error("Failed to fetch redemption history", err);
    }
  };

  useEffect(() => {
    if (activeTab === "redeem") {
      fetchRedemptionHistory();
    }
  }, [activeTab]);

  const renderAssetSelect = () => (
    <div className={styles.assetSelectWrapper}>
      <div
        className={styles.assetSelect}
        onClick={() => setDropdownOpen((p) => !p)}
      >
        <span
          className={`${styles.assetIcon} d-flex justify-content-center align-items-center`}
        >
          {selected.symbol === "GOLD.pf" ? <GoldIcon /> : <BitCoinIcon />}
        </span>
        <span className={styles.assetName}>{selected.symbol}</span>
        <FaAngleDown color="#CECECE" className={styles.dropdownArrow} />
      </div>

      {dropdownOpen && (
        <div className={styles.assetDropdown}>
          {tickers.map((t) => (
            <div
              key={t.symbol}
              className={`${styles.assetOption} ${
                t.symbol === selected.symbol ? styles.selectedOption : ""
              }`}
              onClick={() => {
                setSelected(t);
                setDropdownOpen(false);
              }}
            >
              {t.symbol}
            </div>
          ))}
        </div>
      )}
    </div>
  );

  const renderTabs = () => (
    <div className={styles.tabs}>
      {["opened", "closed", "redeem"].map((tab) => (
        <button
          key={tab}
          onClick={() => {
            setActiveTab(tab);
            setShowHistory(false);
            setRedeemStage("options");
            setRedemptionSuccess(false);
            setErrorMsg("");
          }}
          className={`${styles.tabBtn} ${
            activeTab === tab ? styles.active : ""
          }`}
        >
          {tab === "opened"
            ? "Opened trades"
            : tab === "closed"
            ? "Closed trades"
            : "Redeem"}
        </button>
      ))}
    </div>
  );

  const renderTradeList = () => (
  <div className={styles.tradeList}>
    {(activeTab === "closed" ? closedPositions : positions)
      .filter((p) => (activeTab === "opened" ? p.remaining > 0 : true))
      .slice() // create a shallow copy
      .reverse() // reverse the order
      .map((p) => {
        const isClosed = activeTab === "closed";
        const currentTicker = tickers.find((t) => t.symbol === p.symbol);
        const currentPrice = isClosed
          ? p.finalPrice ?? p.entry
          : currentTicker?.price ?? p.entry;
        const pnl = isClosed
          ? p.pnl
          : p.type === "buy"
          ? currentPrice - p.entry
          : p.entry - currentPrice;
        const isWin = isClosed ? p.win : pnl > 0;

        return (
          <div
            key={p.tradeId}
            className={`${styles.tradeCard} ${
              selected.symbol === p.symbol ? styles.selectedCard : ""
            }`}
            onClick={() =>
              setSelected(currentTicker || { symbol: p.symbol, price: p.entry })
            }
          >
            <div className={styles.tradeRow}>
              <div>
                <div className={styles.symbol}>{p.symbol}</div>
                <div className={styles.price}>
                  {p.payout + p.amount} $PROP{" "}
                  <span
                    className={
                      p.type === "buy" ? styles.arrowUp : styles.arrowDown
                    }
                  >
                    {p.type === "buy" ? (
                      <GoArrowUpRight color="#30970B" />
                    ) : (
                      <GoArrowDownRight color="#970B0B" />
                    )}
                  </span>
                </div>
              </div>
              <div className={`${styles.timer} d-flex align-items-center gap-2`}>
                <GoClock />
                {formatTime(p.remaining)}
              </div>
              <div className={styles.payout}>
                {isWin ? (
                  <>
                    <div className={`${styles.green} mb-1`}>{p.amount} $PROP</div>
                    <div className={styles.green}>
                      +{p.payout + p.amount} $PROP
                    </div>
                  </>
                ) : (
                  <>
                    <div>0 $PROP</div>
                    <div>0 $PROP</div>
                  </>
                )}
              </div>
            </div>
          </div>
        );
      })}
  </div>
);

  const handleRedeem = async () => {
    setLoading(true);
    setErrorMsg("");

    try {
      const response = await axios.post(
        `${env.apiUrl}/api/redeem`,
        {
          type: selectedRedeemOption,
          tierIndex: selectedTier,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("userToken")}`,
          },
        }
      );

      if (response.data.success) {
        setRedeemSummary(response.data.summary);
        setBalance(response.data.summary.newBalance.replace(" $PROP", "")); // Update context balance
        setRedemptionSuccess(true);

        // Fetch updated history
        fetchRedemptionHistory();
      } else {
        setErrorMsg(response.data.error || "Redemption failed");
      }
    } catch (err) {
      console.error(err);
      setErrorMsg(err.response?.data?.error || "Server error");
    } finally {
      setLoading(false);
    }
  };

  const renderRedeemSection = () => {
    // ✅ SUCCESS
    if (redemptionSuccess && redeemSummary) {
      const { type } = redeemSummary;
      return (
        <div className={styles.successContainer}>
          <div className={styles.successHeader}>
            <img
              src="/target.png"
              alt="Success"
              className={styles.successIcon}
            />
            <h4>Congratulations</h4>
            <p>Your redemption was successful</p>
          </div>

          <div className={`${styles.successDetails} d-flex flex-column gap-2`}>
            {type === "discountCodes" && (
              <>
                <div className={styles.detailRow}>
                  <span>Code</span>
                  <span className="d-flex align-items-center">
                    {redeemSummary.code}
                    <IoCopyOutline
                      className="ms-1"
                      role="button"
                      onClick={() => {
                        navigator.clipboard
                          .writeText(redeemSummary.code)
                          .then(() => toast.success("Code copied to clipboard"))
                          .catch(() => toast.error("Failed to copy"));
                      }}
                    />
                  </span>
                </div>
                <div className={styles.detailRow}>
                  <span>Cost</span>
                  <span className={styles.green}>{redeemSummary.cost}</span>
                </div>
                <div className={styles.detailRow}>
                  <span>Reference</span>
                  <span>{redeemSummary.ref}</span>
                </div>
                <div className={styles.detailRow}>
                  <span>Value</span>
                  <span>{redeemSummary.value}</span>
                </div>
                <div className={styles.detailRow}>
                  <span>New balance</span>
                  <span className={styles.green}>
                    {redeemSummary.newBalance}
                  </span>
                </div>
              </>
            )}

            {type === "fundedAccounts" && (
              <>
                <div className={styles.detailRow}>
                  <span>Account size</span>
                  <span>{redeemSummary.accountSize}</span>
                </div>
                <div className={styles.detailRow}>
                  <span>Cost</span>
                  <span className={styles.green}>{redeemSummary.cost}</span>
                </div>
                <div className={styles.detailRow}>
                  <span>Reference</span>
                  <span>{redeemSummary.ref}</span>
                </div>
                <div className={styles.detailRow}>
                  <span>Status</span>
                  <span>{redeemSummary.status}</span>
                </div>
                <div className={styles.detailRow}>
                  <span>New balance</span>
                  <span className={styles.green}>
                    {redeemSummary.newBalance}
                  </span>
                </div>
              </>
            )}

            {type === "cohortSpots" && (
              <>
                <div className={styles.detailRow}>
                  <span>Cohort</span>
                  <span>{redeemSummary.cohort}</span>
                </div>
                <div className={styles.detailRow}>
                  <span>Cost</span>
                  <span className={styles.green}>{redeemSummary.cost}</span>
                </div>
                <div className={styles.detailRow}>
                  <span>Reference</span>
                  <span>{redeemSummary.ref}</span>
                </div>
                <div className={styles.detailRow}>
                  <span>New balance</span>
                  <span className={styles.green}>
                    {redeemSummary.newBalance}
                  </span>
                </div>
              </>
            )}
          </div>

          <button
            className={styles.continueBtn}
            onClick={() => {
              setRedemptionSuccess(false);
              setRedeemStage("options");
              setSelectedTier(0);
            }}
          >
            Done
          </button>
        </div>
      );
    }

    // ✅ HISTORY VIEW
    if (showHistory) {
      return (
        <div className={styles.historyContainer}>
          <div className={styles.historyHeader}>
            <h5>History</h5>
            <button
              className={styles.closeBtn}
              onClick={() => setShowHistory(false)}
            >
              ×
            </button>
          </div>
          <div className={styles.historyTable}>
            <div className={styles.historyRowHeader}>
              <span>Date</span>
              <span>Redeemed</span>
            </div>
            {redemptionHistory.map((item, i) => (
              <div key={i} className={styles.historyRow}>
                <span>
                  {new Date(item.date).toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })}
                </span>

                {item.type === "discountCodes" ? (
                  <span
                    role="button"
                    onClick={() => {
                      navigator.clipboard
                        .writeText(item.redeemed)
                        .then(() => toast.success("Code copied to clipboard"))
                        .catch(() => toast.error("Failed to copy"));
                    }}
                  >
                    {item.redeemed}
                    <IoCopyOutline className="ms-1" />
                    <br />
                    <small>{item.amount}</small>
                  </span>
                ) : (
                  <span>
                    {item.redeemed}
                    <br />
                    <small>{item.amount}</small>
                  </span>
                )}
              </div>
            ))}
          </div>
        </div>
      );
    }

    // ✅ OPTION SELECTION
    if (redeemStage === "options") {
      return (
        <div className={`${styles.tradeList} ${styles.redeemWrapper}`}>
          <div className={`${styles.redeemHeader} d-flex justify-content-end`}>
            <button
              className={styles.historyLink}
              onClick={() => setShowHistory(true)}
            >
              History
            </button>
          </div>

          <div className={styles.redeemOptions}>
            {["discountCodes", "fundedAccounts", "cohortSpots"].map((opt) => (
              <button
                key={opt}
                className={`${styles.redeemBtn} ${
                  selectedRedeemOption === opt ? styles.activeRedeem : ""
                }`}
                onClick={() => {
                  setSelectedRedeemOption(opt);
                  setSelectedTier(0);
                }}
              >
                {opt === "discountCodes"
                  ? "Discount codes"
                  : opt === "fundedAccounts"
                  ? "Funded Accounts"
                  : "Cohort Spots"}
              </button>
            ))}
          </div>

          <button
            className={styles.continueBtn}
            onClick={() => setRedeemStage("tiers")}
          >
            Continue
          </button>
        </div>
      );
    }

    // ✅ TIER SELECTION
    const tierData = {
      discountCodes: {
        title: "Discount codes",
        subtitle: "Select a tier to apply your activation fee",
        options: [
          { label: "10% off", cost: 1000 },
          { label: "20% off", cost: 2000 },
          { label: "30% off", cost: 3000 },
        ],
      },
      fundedAccounts: {
        title: "Redeem funded account",
        subtitle: "Exchange $PROP for instant funded access",
        options: [
          { label: "$10,000 funded account", cost: 5000 },
          { label: "$25,000 funded account", cost: 10000 },
        ],
      },
      cohortSpots: {
        title: "Redeem cohort spot",
        subtitle: "Exchange $PROP for instant funded access",
        options: [{ label: "Next cohort spot", cost: 1000 }],
      },
    };

    const { title, subtitle, options } = tierData[selectedRedeemOption];

    return (
      <div className={styles.discountTierWrapper}>
        <div className={styles.discountHeader}>
          <h5>{title}</h5>
          <p>{subtitle}</p>
        </div>

        <div className={styles.discountOptions}>
          {options.map((tier, i) => (
            <button
              key={i}
              className={`${styles.discountOption} ${
                selectedTier === i ? styles.activeDiscount : ""
              }`}
              onClick={() => setSelectedTier(i)}
            >
              <span className={styles.discountLabel}>{tier.label}</span>
              <span className={styles.discountCost}>{tier.cost} $PROP</span>
            </button>
          ))}
        </div>

        <div className={styles.balanceSection}>
          <hr />
          <p>
            Balance <span>{balance} $PROP</span>
          </p>
        </div>

        {errorMsg && (
          <div className={styles.errorBox}>
            <PiWarning size={20} /> {errorMsg}
          </div>
        )}

        <div className={styles.actionBtns}>
          <button
            className={styles.prevBtn}
            onClick={() => setRedeemStage("options")}
          >
            Previous
          </button>

          <button
            className={styles.continueBtn}
            disabled={selectedTier === null || loading}
            onClick={handleRedeem}
          >
            {loading ? "Processing..." : "Continue"}
          </button>
        </div>
      </div>
    );
  };

  return (
    <div
      className={`${styles.feedWrapper} ${
        mobile ? styles.feedWrapperMobile : ""
      }`}
    >
      {mobile ? (
        <div className={styles.innerWrapper}>
          <div
            className={`${styles.assetHeader} ${styles.closedBody} d-flex justify-content-between align-items-center`}
          >
            {renderAssetSelect()}
            {mobile &&
              (showBody ? (
                <TbSquareRoundedMinus
                  size={20}
                  onClick={() => setShowBody(false)}
                />
              ) : (
                <TbSquareRoundedPlus
                  size={20}
                  onClick={() => setShowBody(true)}
                />
              ))}
          </div>

          {showBody && (
            <div className={styles.assetBody}>
              <p className={styles.assetDesc}>
                {selected.symbol === "GOLD.pf"
                  ? "A synthetic asset modeled on gold price data, designed to mimic real market movements."
                  : "A synthetic crypto asset built from Bitcoin data, replicating real-world volatility for momentum-driven trading opportunities."}
              </p>

              {(activeTab === "redeem" && showHistory) ||
              (activeTab === "redeem" && redemptionSuccess) ? (
                renderRedeemSection()
              ) : activeTab === "redeem" ? (
                <>
                  {renderTabs()}
                  {renderRedeemSection()}
                </>
              ) : (
                <>
                  {renderTabs()}
                  {renderTradeList()}
                </>
              )}
            </div>
          )}
        </div>
      ) : (
        <>
          <div
            className={`${styles.assetHeader} d-flex justify-content-between align-items-center`}
          >
            {renderAssetSelect()}
          </div>

          <div className={styles.assetBody}>
            <p className={styles.assetDesc}>
              {selected.symbol === "GOLD.pf"
                ? "A synthetic asset modeled on gold price data, designed to mimic real market movements."
                : "A synthetic crypto asset built from Bitcoin data, replicating real-world volatility for momentum-driven trading opportunities."}
            </p>

            {(activeTab === "redeem" && showHistory) ||
            (activeTab === "redeem" && redemptionSuccess) ? (
              renderRedeemSection()
            ) : activeTab === "redeem" ? (
              <>
                {renderTabs()}
                {renderRedeemSection()}
              </>
            ) : (
              <>
                {renderTabs()}
                {renderTradeList()}
                <DiscordBanner />
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default MarketFeed;
